import sharedStyles from "../../shared/styles.js";
var styles = {
  // Bootstrap default margin-bottom for .panel is 20px but for some reason the
  // bootstrap theme in AP overrides it to 0. Because this is really yuck if
  // we don't fix it, we'll set the inline style for .panel to have 0 bottom
  // margin and wrap the whole thing in a container element that has bottom margin
  // (AP has .panel {margin-bottom: 0 !important } and we can't override with
  // an inline !important because (believe it or not) react doesn't support !important
  //
  // Ideally at some future day we'll standardize the styles between PC and AP
  // and we can get rid of this
  container: {
    marginBottom: "20px"
  },
  panel: {
    marginBottom: "0px"
  },
  header: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  iconArrow: {
    width: "24px",
    height: "21px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  li: {
    display: "flex",
    justifyContent: "space-between",
    padding: "1px 0"
  },
  left: {
    marginRight: "5px"
  },
  right: {
    maxWidth: "60%"
  },
  panelTitle: {
    fontSize: "inherit"
  },
  emptyText: {
    textAlign: "center",
    padding: "10px",
    backgroundColor: sharedStyles.colorLightGray,
    borderRadius: "3px",
    marginBottom: "20px"
  }
};
export default styles;